<div *ngIf="dataLinkReset" class="modal dataLinkAlertModel" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always flex--space-between">
          <h5 class="modal-title">{{appCopy.panelHeaderCopy1['alertHeading'+selectedLanguage]}}</h5>
          <i class="icon" (click)="cancelModal()">cross</i>
        </div>
      </div>
      <div class="modal-body">
        <p>{{appCopy.panelHeaderCopy1['alertContent'+selectedLanguage]}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-gray" (click)="goToFlightFinder()">{{appCopy.panelHeaderCopy1['alertOKButton'+selectedLanguage]}}</button>
        <button type="button" class="btn btn-primary" (click)="cancelModal()">{{appCopy.panelHeaderCopy1['alertCancelButton'+selectedLanguage]}}</button>
      </div>
    </div>
  </div>
</div>

<section class="container current-booking-section">

  <div class="row booking-content">
<!-- used to output booking panels -->
<router-outlet></router-outlet>
</div>

  <!-- <div class="row">
    <div class="col-md-8 col-md-offset-1 fadeInUp">

      <div class="partner-logo partner-logo--large" *ngIf="currentPartner !== null && currentPartner !== 'NONE'">
        <hr class="margin-bottom-24">
        <span class="serviced-by">Serviced by</span>
        <span class="serviced-by partner-logo__img logo-AIRPORTR"></span>

        <span class="partnership-with">In partnership with</span>
        <span class="partnership-with partner-logo__img logo-{{currentPartner}}"></span>
      </div>
    </div>
  </div> -->

</section>

<app-notifications></app-notifications>
<app-modal [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"></app-modal>
<app-tooltip></app-tooltip>
<app-page-loader></app-page-loader>
